<section>
  <header>
    <h2 class="heading-underline">Conditions</h2>
  </header>
  <p>Select a field, operator, and value to filter by</p>
  <div class="conditions-grid">
    <div>
      <app-kp-autocomplete
        [placeholder]="'<entity>.<path-to-field>'"
        [selected]="this.viewFieldPath"
        [filterFunction]="this.filterFn.bind(this)"
        [tabHandlerFunction]="this.tabHandlerFn.bind(this)"
        [focusInputOnLoad]="true"
        [embeddedDropDown]="true"
        [inputWidth]="'100%'"
        (selectedChange)="fieldSelected($event)"
        >
      </app-kp-autocomplete>
    </div>
    <span style="color: lightgray; font-size: 10px; padding-left: 12px">Use 'Tab' to auto-complete</span>
    <mat-select class="full-width" placeholder="Operator..." [(ngModel)]="viewOperator" (ngModelChange)="operatorUpdated()">
      @for (op of Operators; track $index) {
        <mat-option [value]="op">
          {{ op }}
        </mat-option>
      }
    </mat-select>
    <input
      class="full-width"
      placeholder="Enter value..."
      type="text"
      [(ngModel)]="viewValue"
      [hidden]="viewOperator === Populated || viewOperator === NotPopulated"
      />
    </div>
    <button style="min-height: 0" theme="medium" [disabled]="!isValid()" (click)="onAddOrUpdateCondition()">
      {{ mode === Mode.INSERT ? 'Insert' : 'Update' }}
    </button>
  </section>
